import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import FilterListIcon from "@mui/icons-material/FilterList";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ArrowForwardIos, DeleteOutline, Edit } from "@mui/icons-material";
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// import { DateRangePicker, SingleInputDateRangeField } from '@mui/x-date-pickers-pro';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import axios from "axios";
import DeleteModal from "../../components/Modals/DeleteModal";
import { toast } from "react-toastify";
import NotFound from "../../components/SharedModule/NotFound";
import { useSelector } from "react-redux";

export default function Offers() {
  // const token = "1|uXWWHVAxUbLR94IuQ07nZUT5306vlnjfGFo4AUoR16bcf002";

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // offer data table

  const [offers, setOffers] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedOffers, setSelectedOffers] = useState([]);

  const [showFilterDropdown, setShowFilterDropdown] = useState(false);

  const [categories, setCategories] = useState([]);

  const getOffers = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/offers`, {
        headers,
      });
      console.log(response.data.data.offers);
      setOffers(response.data.data.offers);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      field: "Code",
      headerName: "Code",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "Name",
      headerName: "Name",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Type",
      headerName: "Offer Type",
      flex: 1,
      minWidth: 1.2,
    },
    {
      field: "Discount",
      headerName: "Discount Type",
      flex: 0.9,
      minWidth: 110,
    },
    {
      field: "Value",
      headerName: "Discount Value",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "Price",
      headerName: "Offer Price",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "Date",
      headerName: "Offer Date",
      flex: 0.8,
      minWidth: 100,
      renderCell: (params) => {
        const { StartDate, EndDate } = params.row;
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: "1.8",
              width: "100%",
            }}
          >
            <span>{StartDate}</span>
            <span>{EndDate}</span>
          </div>
        );
      },
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 110,
      renderCell: (params) => {
        const handleEdit = (event) => {
          event.stopPropagation();
          navigate(`/offers/edit/${params.row.id}`);
        };
        const handleDelete = (event) => {
          event.stopPropagation();
          confirmDelete(params.row.id);
        };
        const handleNavigate = (event) => {
          event.stopPropagation();
          navigate(`/offers/${params.row.id}`);
        };
        // const handleRepeat = (event) => {
        //   event.stopPropagation();
        //   handleShowRepeat();
        // };

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            {/* <IconButton
              onClick={handleRepeat}
              color="info"
              style={{ width: "30%" }}
              aria-label="repeat"
            >
              <Repeat />
            </IconButton> */}

            <IconButton
              onClick={handleEdit}
              color="default"
              style={{ width: "30%" }}
              aria-label="edit"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={handleDelete}
              color="error"
              style={{ width: "30%" }}
              aria-label="delete"
            >
              <DeleteOutline />
            </IconButton>
            <IconButton
              onClick={handleNavigate}
              color="default"
              style={{ width: "30%" }}
              aria-label="edit"
            >
              <ArrowForwardIos />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  const filteredRows = offers
    .filter((offer) => {
      const matchesSearch =
        offer.code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        offer.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        offer.offer_type_label
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());

      const offerCategoryNames = offer.categories?.map((cat) => cat.name) || [];

      const matchesCategory =
        selectedOffers.length === 0 ||
        offerCategoryNames.some((catName) => selectedOffers.includes(catName));

      return matchesSearch && matchesCategory;
    })
    .map((offer) => ({
      id: offer.id,
      Code: offer.code,
      Name: offer.name,
      Type: offer.offer_type_label || "",
      Discount: offer.pricing?.offer_discount?.type || "None",
      Value: offer.pricing?.offer_discount?.value || "None",
      Price: offer.pricing?.total_price || "None",
      StartDate: formatDate(offer.validity?.dates?.start),
      EndDate: formatDate(offer.validity?.dates?.end),
      Status: offer.is_active ? "Active" : "Inactive",
      Actions: "",
      rawData: offer,
    }));

  // delete offer

  const [offerId, setOfferId] = useState(null);

  const [showDelete, setShowDelete] = useState(false);

  const confirmDelete = (id) => {
    setShowDelete(true);
    setOfferId(id);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setOfferId(null);
  };

  const deleteOffer = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/offers/${offerId}`,
        {
          headers,
        }
      );
      toast.warning("Offer Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getOffers();
    } catch (error) {
      toast.error("Failed To Delete This Offer.");
      console.log(error.message);
    }
  };

  // repeat offer

  // const [showRepeat, setShowRepeat] = useState(false);

  // const handleShowRepeat = () => {
  //     setShowRepeat(!showRepeat);
  // };

  const navigate = useNavigate();

  const goToAddOffer = () => {
    navigate("/offers/AddNewOffer");
  };

  useEffect(() => {
    const allCategoryNames = offers
      .flatMap((offer) => offer?.categories?.map((cat) => cat?.name))
      .filter(Boolean);

    const uniqueCategories = [...new Set(allCategoryNames)];
    setCategories(uniqueCategories);
  }, [offers]);

  useEffect(() => {
    getOffers();
  }, []);

  return (
    <>
      {/* delete offer  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this offer?"}
        deleteFunction={deleteOffer}
      />
      {/* repeat modal  */}
      {/* {showRepeat && (
         <div
           className="modal fade show"
           id="exampleModal"
           tabIndex="-1"
           role="dialog"
           aria-labelledby="exampleModalLabel"
           aria-hidden="true"
           style={{ display: "block" }}
         >
           <div className="stock-modal modal-dialog modal-lg" role="document">
             <div className="modal-content">
               <div className="modal-header bg-light">
                 <p
                   className="modal-title m-2 fs-3 fw-semibold"
                   id="exampleModalLabel"
                 >
                   Select Repeating date
                 </p>
               </div>
               <div className="modal-body px-3 py-2">
                 <LocalizationProvider dateAdapter={AdapterDayjs}>
                   <DemoContainer components={["SingleInputDateRangeField"]}>
                     <DateRangePicker
                       slots={{ field: SingleInputDateRangeField }}
                       name="allowedRange"
                     />
                   </DemoContainer>
                 </LocalizationProvider>
               </div>
               <div className="stock-modalFooter modal-footer d-flex justify-content-evenly mt-3">
                 <button
                   type="button"
                   className="btn btn-dark fs-6"
                   onClick={handleShowRepeat}
                 >
                   Save
                 </button>
                 <button
                   type="button"
                   className="btn btn-outline-dark fs-6"
                   onClick={handleShowRepeat}
                 >
                   Close
                 </button>
               </div>
             </div>
           </div>
         </div>
       )} */}
      {/* offers data  */}
      <div className="m-4">
        {/* offers head  */}
        <div className="notifications-display d-flex justify-content-between align-items-center">
          <p className="my-sm-2 fs-5 my-md-0 fw-bold">Offers</p>
          <button
            onClick={goToAddOffer}
            className="btn border border-1 text-muted p-2"
          >
            <i className="fa-solid fa-plus fw-light mx-1"></i>
            Add New Offer
          </button>
        </div>
        {/* offers search  */}
        <div className="notif-search d-flex justify-content-center justify-content-md-end align-items-center my-3">
          {/* text search  */}
          <FormControl
            sx={{ width: "40ch" }}
            className="me-3 mx-md-3"
            variant="outlined"
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Search by Code, name, type...
            </InputLabel>
            <OutlinedInput
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              id="outlined-adornment-password"
              type={"text"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">{<SearchIcon />}</IconButton>
                </InputAdornment>
              }
              label="Search by Code, name, type..."
            />
          </FormControl>
          {/* filteration  */}
          <div className="position-relative border border-1 p-2 mb-4 rounded-3">
            <IconButton onClick={() => setShowFilterDropdown((prev) => !prev)}>
              <FilterListIcon />
            </IconButton>
            {showFilterDropdown && (
              <div
                className="position-absolute mt-2 rounded shadow"
                style={{
                  width: "240px",
                  right: 0,
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                  padding: "16px",
                  zIndex: 10,
                }}
              >
                <p className="fw-bold mb-2">Filter by Category</p>
                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {categories.map((cat) => (
                    <label
                      key={cat}
                      className="d-flex align-items-center mb-2"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        gap: "8px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedOffers.includes(cat)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedOffers((prev) => [...prev, cat]);
                          } else {
                            setSelectedOffers((prev) =>
                              prev.filter((c) => c !== cat)
                            );
                          }
                        }}
                      />
                      <span>{cat}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* offers table  */}
        <div>
          {filteredRows && filteredRows.length > 0 ? (
            <div className="scrollable-table-wrapper">
              <div>
                <Paper sx={{ width: "100%" }}>
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    sx={{ border: 0 }}
                    slotProps={{
                      pagination: {
                        sx: {
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                      },
                    }}
                  />
                </Paper>
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Offers Yet. All your Offers will appear here once you get started."
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
